(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-form-commercial"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.rowan-form3').forEach(function (root) {
    if (root.dataset.rf3Init) return;
    root.dataset.rf3Init = '1';

    var apiBase   = (root.dataset.apiBase || '').replace(/\/$/, '');
    var formId    = root.dataset.formId || '';
    var thankyou  = root.dataset.thankyou || '/pages/thank-you';
    var form      = root.querySelector('.rf3__form');
    var errorEl   = root.querySelector('[data-error]');
    var submitBtn = root.querySelector('[data-submit]');
    var fileInput = root.querySelector('.rf3__file');
    var fileList  = root.querySelector('[data-file-list]');
    var picked    = [];

    // reCAPTCHA state
    var captchaEl = root.querySelector('[data-captcha]');
    var siteKey   = root.dataset.recaptchaKey || '';
    var widgetId  = null;

    var ALLOWED = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'application/pdf'];
    var MAX_BYTES = 25 * 1024 * 1024;

    // ---- reCAPTCHA v2 setup: load the API once, render this widget explicitly ----
    function rf3EnsureRecaptcha() {
      if (document.querySelector('script[data-recaptcha-api]')) return;
      var s = document.createElement('script');
      s.src = 'https://www.google.com/recaptcha/api.js';
      s.async = true; s.defer = true;
      s.setAttribute('data-recaptcha-api', '1');
      document.head.appendChild(s);
    }
    if (captchaEl && siteKey) {
      rf3EnsureRecaptcha();
      var rf3Tries = 0;
      (function rf3Render() {
        if (window.grecaptcha && window.grecaptcha.render) {
          try { widgetId = window.grecaptcha.render(captchaEl, { sitekey: siteKey }); } catch (err) {}
        } else if (rf3Tries++ < 100) {
          setTimeout(rf3Render, 100);
        }
      })();
    }

    root.querySelector('[data-browse]').addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      Array.prototype.forEach.call(fileInput.files, function (f) {
        if (ALLOWED.indexOf(f.type) === -1 && !/\.(jpe?g|png|gif|svg|pdf)$/i.test(f.name)) {
          showError(f.name + ' is not a supported format.'); return;
        }
        if (f.size > MAX_BYTES) { showError(f.name + ' is larger than 25MB.'); return; }
        picked.push(f);
      });
      renderFiles();
    });

    function renderFiles() {
      fileList.innerHTML = '';
      picked.forEach(function (f, i) {
        var li = document.createElement('li');
        var name = document.createElement('span'); name.textContent = f.name;
        var rm = document.createElement('button');
        rm.type = 'button'; rm.innerHTML = '&times;'; rm.setAttribute('aria-label', 'Remove ' + f.name);
        rm.addEventListener('click', function () { picked.splice(i, 1); renderFiles(); });
        li.appendChild(name); li.appendChild(rm); fileList.appendChild(li);
      });
    }

    function showError(msg) {
      errorEl.textContent = msg; errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async function uploadFile(file) {
      var mod = await import('https://esm.sh/@vercel/blob@0.27.3/client');
      var blob = await mod.upload(file.name, file, {
        access: 'public',
        handleUploadUrl: apiBase + '/api/upload',
        clientPayload: JSON.stringify({ formId: formId })
      });
      return { url: blob.url, name: file.name };
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      if (form.querySelector('[name="company_website"]').value) return; // honeypot

      if (!form.checkValidity()) {
        var firstInvalid = form.querySelector(':invalid');
        showError('Please complete all required fields.');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      // Required checkbox groups (at least one)
      var groupsOk = true;
      root.querySelectorAll('[data-required-group]').forEach(function (grp) {
        if (groupsOk && !grp.querySelector('input:checked')) {
          showError('Please select at least one option for "' + (grp.dataset.groupLabel || 'a required field') + '".');
          groupsOk = false;
        }
      });
      if (!groupsOk) return;

      // reCAPTCHA — require the box to be ticked (only when the widget is present)
      var recaptchaToken = '';
      if (captchaEl && siteKey) {
        recaptchaToken = (window.grecaptcha && widgetId !== null) ? window.grecaptcha.getResponse(widgetId) : '';
        if (!recaptchaToken) { showError('Please confirm you are not a robot.'); return; }
      }

      submitBtn.disabled = true;
      var original = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';

      try {
        // Upload signature file(s)
        var files = [];
        for (var i = 0; i < picked.length; i++) {
          submitBtn.textContent = 'Uploading file ' + (i + 1) + '/' + picked.length + '…';
          files.push(await uploadFile(picked[i]));
        }

        // Collect fields (concatenate multi-value groups like checkboxes)
        var fields = {};
        new FormData(form).forEach(function (value, key) {
          if (key === 'company_website' || key === 'signature') return;
          if (value === '' || value == null) return;
          if (fields[key] !== undefined) fields[key] = fields[key] + ', ' + value;
          else fields[key] = value;
        });

        // Combine phone country + number into one field
        if (fields.phone_number) {
          fields.phone = (fields.phone_country ? fields.phone_country + ' ' : '') + fields.phone_number;
        }
        delete fields.phone_country;
        delete fields.phone_number;

        submitBtn.textContent = 'Submitting…';
        var res = await fetch(apiBase + '/api/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formId: formId, fields: fields, files: files, recaptchaToken: recaptchaToken })
        });
        if (!res.ok) {
          var data = await res.json().catch(function () { return {}; });
          throw new Error(data.error || 'Something went wrong. Please try again.');
        }
        window.location.href = thankyou;
      } catch (err) {
        showError(err.message || 'Submission failed. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        if (window.grecaptcha && widgetId !== null) window.grecaptcha.reset(widgetId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-form-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.rowan-form2').forEach(function (root) {
    if (root.dataset.rf2Init) return;
    root.dataset.rf2Init = '1';

    var apiBase  = (root.dataset.apiBase || '').replace(/\/$/, '');
    var formId   = root.dataset.formId || '';
    var thankyou = root.dataset.thankyou || '/pages/thank-you';
    var form     = root.querySelector('.rf2__form');
    var errorEl  = root.querySelector('[data-error]');
    var submitBtn= root.querySelector('[data-submit]');

    // reCAPTCHA state
    var captchaEl = root.querySelector('[data-captcha]');
    var siteKey   = root.dataset.recaptchaKey || '';
    var widgetId  = null;

    // ---- reCAPTCHA v2 setup: load the API once, render this widget explicitly ----
    function rf2EnsureRecaptcha() {
      if (document.querySelector('script[data-recaptcha-api]')) return;
      var s = document.createElement('script');
      s.src = 'https://www.google.com/recaptcha/api.js';
      s.async = true; s.defer = true;
      s.setAttribute('data-recaptcha-api', '1');
      document.head.appendChild(s);
    }
    if (captchaEl && siteKey) {
      rf2EnsureRecaptcha();
      var rf2Tries = 0;
      (function rf2Render() {
        if (window.grecaptcha && window.grecaptcha.render) {
          // theme:'dark' suits the white-on-dark design; change to 'light' if your background is light
          try { widgetId = window.grecaptcha.render(captchaEl, { sitekey: siteKey, theme: 'dark' }); } catch (err) {}
        } else if (rf2Tries++ < 100) {
          setTimeout(rf2Render, 100);
        }
      })();
    }

    function showError(msg) {
      errorEl.textContent = msg; errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      if (form.querySelector('[name="company_website"]').value) return; // honeypot

      if (!form.checkValidity()) {
        var firstInvalid = form.querySelector(':invalid');
        showError('Please complete all required fields.');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      // reCAPTCHA — require the box to be ticked (only when the widget is present)
      var recaptchaToken = '';
      if (captchaEl && siteKey) {
        recaptchaToken = (window.grecaptcha && widgetId !== null) ? window.grecaptcha.getResponse(widgetId) : '';
        if (!recaptchaToken) { showError('Please confirm you are not a robot.'); return; }
      }

      submitBtn.disabled = true;
      var original = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';

      try {
        var fields = {};
        new FormData(form).forEach(function (value, key) {
          if (key === 'company_website') return;
          if (value !== '' && value != null) fields[key] = value;
        });

        var res = await fetch(apiBase + '/api/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formId: formId, fields: fields, files: [], recaptchaToken: recaptchaToken })
        });
        if (!res.ok) {
          var data = await res.json().catch(function () { return {}; });
          throw new Error(data.error || 'Something went wrong. Please try again.');
        }
        window.location.href = thankyou;
      } catch (err) {
        showError(err.message || 'Submission failed. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        if (window.grecaptcha && widgetId !== null) window.grecaptcha.reset(widgetId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rowan-form-quote-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.rowan-form');
  roots.forEach(function (root) {
    if (root.dataset.rfInit) return;
    root.dataset.rfInit = '1';

    var apiBase   = (root.dataset.apiBase || '').replace(/\/$/, '');
    var formId    = root.dataset.formId || '';
    var thankyou  = root.dataset.thankyou || '/pages/thank-you';
    var form      = root.querySelector('.rf__form');
    var errorEl   = root.querySelector('[data-error]');
    var submitBtn = root.querySelector('[data-submit]');
    var fileInput = root.querySelector('.rf__file');
    var drop      = root.querySelector('[data-drop]');
    var fileList  = root.querySelector('[data-file-list]');
    var picked    = [];

    // reCAPTCHA state
    var captchaEl = root.querySelector('[data-captcha]');
    var siteKey   = root.dataset.recaptchaKey || '';
    var widgetId  = null;

    // ---- reCAPTCHA v2 setup: load the API once, render this widget explicitly ----
    function rfEnsureRecaptcha() {
      if (document.querySelector('script[data-recaptcha-api]')) return;
      var s = document.createElement('script');
      s.src = 'https://www.google.com/recaptcha/api.js';
      s.async = true; s.defer = true;
      s.setAttribute('data-recaptcha-api', '1');
      document.head.appendChild(s);
    }
    if (captchaEl && siteKey) {
      rfEnsureRecaptcha();
      var rfTries = 0;
      (function rfRender() {
        if (window.grecaptcha && window.grecaptcha.render) {
          try { widgetId = window.grecaptcha.render(captchaEl, { sitekey: siteKey }); } catch (err) {}
        } else if (rfTries++ < 100) {
          setTimeout(rfRender, 100);
        }
      })();
    }

    // Quantity stepper
    root.querySelectorAll('.rf__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = root.querySelector('.rf__step-input');
        var val = parseInt(input.value || '0', 10);
        if (isNaN(val)) val = 0;
        val = btn.dataset.step === 'up' ? val + 1 : Math.max(0, val - 1);
        input.value = val;
      });
    });

    // File selection (browse + drag/drop)
    root.querySelector('[data-browse]').addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); });
    ['dragover', 'dragenter'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
    });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer) addFiles(e.dataTransfer.files); });

    var ALLOWED = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];
    var MAX_BYTES = 25 * 1024 * 1024; // 25MB per file

    function addFiles(fileListObj) {
      Array.prototype.forEach.call(fileListObj, function (f) {
        if (ALLOWED.indexOf(f.type) === -1 && !/\.(jpe?g|png|gif|svg)$/i.test(f.name)) {
          showError(f.name + ' is not a supported format.'); return;
        }
        if (f.size > MAX_BYTES) { showError(f.name + ' is larger than 25MB.'); return; }
        picked.push(f);
      });
      renderFiles();
    }

    function renderFiles() {
      fileList.innerHTML = '';
      picked.forEach(function (f, i) {
        var li = document.createElement('li');
        var name = document.createElement('span');
        name.textContent = f.name;
        var rm = document.createElement('button');
        rm.type = 'button'; rm.innerHTML = '&times;'; rm.setAttribute('aria-label', 'Remove ' + f.name);
        rm.addEventListener('click', function () { picked.splice(i, 1); renderFiles(); });
        li.appendChild(name); li.appendChild(rm);
        fileList.appendChild(li);
      });
    }

    function showError(msg) {
      errorEl.textContent = msg; errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }

    // Upload one file directly to Vercel Blob, return { url, name }
    async function uploadFile(file) {
      var mod = await import('https://esm.sh/@vercel/blob@0.27.3/client');
      var blob = await mod.upload(file.name, file, {
        access: 'public',
        handleUploadUrl: apiBase + '/api/upload',
        clientPayload: JSON.stringify({ formId: formId })
      });
      return { url: blob.url, name: file.name };
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearError();

      // Honeypot
      if (form.querySelector('[name="company_website"]').value) return;

      // Native required-field validation
      if (!form.checkValidity()) {
        var firstInvalid = form.querySelector(':invalid');
        showError('Please complete all required fields.');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      // reCAPTCHA — require the box to be ticked (only when the widget is present)
      var recaptchaToken = '';
      if (captchaEl && siteKey) {
        recaptchaToken = (window.grecaptcha && widgetId !== null) ? window.grecaptcha.getResponse(widgetId) : '';
        if (!recaptchaToken) { showError('Please confirm you are not a robot.'); return; }
      }

      submitBtn.disabled = true;
      var original = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';

      try {
        // 1. Upload files to Blob
        var files = [];
        for (var i = 0; i < picked.length; i++) {
          submitBtn.textContent = 'Uploading file ' + (i + 1) + '/' + picked.length + '…';
          files.push(await uploadFile(picked[i]));
        }

        // 2. Collect text fields
        var fields = {};
        new FormData(form).forEach(function (value, key) {
          if (key === 'company_website' || key === 'file') return;
          if (value !== '' && value != null) fields[key] = value;
        });

        // 3. Submit to backend
        submitBtn.textContent = 'Submitting…';
        var res = await fetch(apiBase + '/api/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formId: formId, fields: fields, files: files, recaptchaToken: recaptchaToken })
        });
        if (!res.ok) {
          var data = await res.json().catch(function () { return {}; });
          throw new Error(data.error || 'Something went wrong. Please try again.');
        }

        // 4. Redirect to thank-you page
        window.location.href = thankyou;
      } catch (err) {
        showError(err.message || 'Submission failed. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = original;
        if (window.grecaptcha && widgetId !== null) window.grecaptcha.reset(widgetId);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
